/**
 * THE THREE DISCIPLINES OF STOICISM — canonical taxonomy (Founder
 * architecture, 2026-07-11, PERMANENT & IMMUTABLE).
 *
 * Every Journey belongs to exactly ONE discipline: logic | physics | ethics.
 * This module is the frontend's single source of truth. Consumers:
 * Academy (Three Disciplines section), Living Library CMS (discipline
 * selector), and every future feature (Wings, filters, search,
 * recommendations, breadcrumbs, JSON-LD). Never duplicate this list and
 * never introduce an alternative categorization.
 *
 * Backend mirror: STOIC_DISCIPLINES / STOIC_DISCIPLINE_META in
 * /app/backend/library_service.py — taxonomy API: GET /api/library/disciplines.
 * Labels live in the i18n dictionaries under `academy.disc.{id}.*` and
 * `admin.libcms.discipline.{id}` (EN/NL parity enforced).
 * Full architecture: /app/memory/ARCHITECTURE.md ("The Three Disciplines").
 */
export const STOIC_DISCIPLINES = [
  { id: "logic",   numeral: "I" },
  { id: "physics", numeral: "II" },
  { id: "ethics",  numeral: "III" },
];

export const DISCIPLINE_IDS = STOIC_DISCIPLINES.map((d) => d.id);
